<div class="trial-sizes-panel">
  <span class="trial-sizes-label">Trial sizes</span>
  <div class="trial-sizes-chips">
    @for (size of trialSizes(); track $index) {
      <span class="chip">
        @if (editingChipIndex() === $index) {
          <input
            class="chip-input"
            type="number"
            [value]="size"
            min="1"
            (blur)="onChipBlur($index, $event)"
            (keydown)="onChipKeydown($index, $event)"
            #chipInput
          />
        } @else {
          <span
            class="chip-value"
            [class.chip-editable]="editableTrialSizes()"
            (dblclick)="editableTrialSizes() && startEditChip($index)"
          >
            {{ size }}
          </span>
          @if (editableTrialSizes()) {
            <button class="chip-remove" (click)="removeTrialSize($index)" title="Remove">&times;</button>
          }
        }
      </span>
    }
    @if (editableTrialSizes()) {
      <button class="chip chip-add" (click)="addTrialSize()">+ Add</button>
    }
  </div>
  <button class="simulate-btn" (click)="onSimulateClick()">&#9654; Run</button>
</div>

@if (showTable()) {
  <div class="table-container">
    <dojo-data-input [config]="dataInputConfig()" [editable]="false" />
  </div>
}

@if (showChart() && results().length > 0) {
  <div
    echarts
    class="chart"
    [style.--chart-height.px]="chartHeight()"
    [options]="adaptedOptions()"
    [initOpts]="initOpts"
  ></div>
}
